import { scoreToPercentileSync } from '@/helpers/helpers.js';
import { getReputationTier, useTierSet } from '@/helpers/reputationTiersHelper.js';

/**
 * Generate tooltip text for reputation badge
 * @param {Number} score - Raw reputation score
 * @param {Boolean} isCurrentUser - Whether this is the current user's score
 * @param {String} tierSetName - Optional tier set name to use
 * @returns {String} Tooltip text
 */
export function getReputationTooltip(score, isCurrentUser, tierSetName = null) {
  const percentileValue = Math.round(scoreToPercentileSync(score));
  const tierValue = getReputationTier(percentileValue, tierSetName);
  
  if (isCurrentUser) {
    return `${tierValue.name} Tier: ${tierValue.description} (Above ${percentileValue}% of users)`;
  } else {
    // Show range for other users if available
    let low, high;
    if (tierValue.range) {
      const match = tierValue.range.match(/(\d+)[^\d]+(\d+)/);
      if (match) {
        low = match[1];
        high = match[2];
      }
    } else if (tierValue.percentileRange) {
      if (Array.isArray(tierValue.percentileRange)) {
        low = tierValue.percentileRange[0];
        high = tierValue.percentileRange[1];
      } else if (typeof tierValue.percentileRange === 'string') {
        const match = tierValue.percentileRange.match(/(\d+)[^\d]+(\d+)/);
        if (match) {
          low = match[1];
          high = match[2];
        }
      }
    }
    let tierRangeText = (low !== undefined && high !== undefined)
      ? `${tierValue.name} Tier Range: ${low}% - ${high}%`
      : `${tierValue.name} Tier Range`;
    return tierRangeText;
  }
}
